import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
    const { user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        // Update active tab based on current route
        if (location.pathname.includes('therapeutes')) {
            setActiveTab('therapists');
        } else if (location.pathname.includes('clients')) {
            setActiveTab('customers');
        } else if (location.pathname.includes('capsules')) {
            setActiveTab('capsules');
        } else if (location.pathname.includes('melanges')) {
            setActiveTab('mixtures');
        } else if (location.pathname.includes('selections')) {
            setActiveTab('selections');
        }
        else if (location.pathname.includes('popups')) {
            setActiveTab('popups');
        }
    }, [location.pathname]);

    const initials = `${user.firstname.charAt(0)}${user.lastname.charAt(0)}`;

    return (
        <div className="max-w-full mx-auto p-6">
            <div className="flex items-center space-x-4 mb-6">
                <div className="w-16 h-16 bg-primary text-primary-content rounded-full flex items-center justify-center text-2xl font-semibold">
                    {initials}
                </div>
                <div>
                    <h1 className="text-2xl font-bold">Administration</h1>
                    <p className="text-base-content/70">{user.firstname} {user.lastname}</p>
                </div>
            </div>
            <div className="flex gap-x-2 border-b border-base-300 pb-2 mb-4">
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'capsules' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('capsules')}
                >
                    Capsules
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'therapists' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('therapeutes')}
                >
                    Thérapeutes
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'customers' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('clients')}
                >
                    Clients
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'mixtures' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('melanges')}
                >
                    Mélanges
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'selections' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('selections')}
                >
                    Sélections
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'popups' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('popups')}
                >
                    Popups
                </button>
            </div>
            <div>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminDashboard; 